import { Theme } from '@mui/material';

export const raList = (theme: Theme) => ({
    styleOverrides: {
        root: {
            ['& .RaList-main']: {
                overflowX: 'hidden',
                pr: 2,
                pl: 2,
                borderRadius: theme.shape.borderRadius,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.dividerDark}`,
                boxShadow: theme.shape.boxShadow,

                ['& .MuiPaper-root']: {
                    overflowX: 'auto',
                    my: 0,
                    mx: -1,
                },
                ['& .MuiTableCell-root']: {
                    borderBottom: 'none',
                },
                ['& .MuiTablePagination-toolbar']: {
                    minHeight: '48px !important',
                },
                ['& .MuiToolbar-root']: {
                    alignItems: 'center',
                },
                ['& .RaBulkActionsToolbar-toolbar']: {
                    display: 'none',
                },
            },
        },
    },
});
